import { render, staticRenderFns } from "./follower.vue?vue&type=template&id=1f995fb1&scoped=true"
import script from "./follower.vue?vue&type=script&lang=js"
export * from "./follower.vue?vue&type=script&lang=js"
import style0 from "./follower.vue?vue&type=style&index=0&id=1f995fb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f995fb1",
  null
  
)

export default component.exports